import { render } from "./DashboardGameMaster.vue?vue&type=template&id=2a6e4ee6&scoped=true"
import script from "./DashboardGameMaster.vue?vue&type=script&lang=js"
export * from "./DashboardGameMaster.vue?vue&type=script&lang=js"

import "./DashboardGameMaster.vue?vue&type=style&index=0&id=2a6e4ee6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6e4ee6"]])

export default __exports__